/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { makeSlug } from '@trello/urls';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { View } from 'app/scripts/views/internal/view';
import popoverShare from 'app/scripts/views/templates/popover_share';
import { dontUpsell } from '@trello/browser';
import { Controller } from 'app/scripts/controller';
import { Auth } from 'app/scripts/db/auth';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import {
  renderComponent,
  ComponentWrapper,
} from 'app/src/components/ComponentWrapper';
import { print } from '@trello/browser-compatibility';
import { BusinessClassIcon } from '@trello/nachos/icons/business-class';
import {
  UpgradePromptPill,
  UpgradeSmartComponent,
} from 'app/src/components/UpgradePrompts';
import { PlanSelectionOverlay } from 'app/src/components/FreeTrial';
import { renderUpgradePrompt } from 'app/src/components/UpgradePrompts/renderUpgradePrompt';
import { l } from 'app/scripts/lib/localize';
import { Analytics } from '@trello/atlassian-analytics';
import { featureFlagClient } from '@trello/feature-flag-client';
import { ExportPopoverContent } from 'app/src/components/ExportPopoverContent';
import _ from 'underscore';
import { clientVersion } from '@trello/config';
import { dismissFlag, showFlag } from '@trello/nachos/experimental-flags';
import { forTemplate } from '@trello/i18n';

let featureFlag;

const format = forTemplate('popover_share');

class SharePopoverView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'print and export';

    featureFlag = featureFlagClient.get(
      'fv.export-service-export-board',
      false,
    );

    this.prototype.events = {
      'click .js-print': 'printModel',
      'click .js-export-json': 'exportJSON',
      'click .js-export': 'renderExportPopover',
      'click .js-export-csv': 'exportCSV',
    };
  }

  constructor(props) {
    super(props);
    this.upgradePromptPill = this.upgradePromptPill.bind(this);
    this.debouncedTracedExport = _.debounce(this.tracedExportCSV, 2500, true);
  }

  remove() {
    if (typeof this.unmountPill === 'function') {
      this.unmountPill();
    }
    return super.remove(...arguments);
  }

  render() {
    const org = this.model.getOrganization();

    const data = this.model.toJSON();
    data.hasCsvExport = false;

    data.hasOrganization = this.model.hasOrganization();
    data.upgradeUrl = Controller.getUpgradeUrl(this.model);
    data.isAdDismissed = Auth.me().isAdDismissed('share-popover');

    if (
      org != null &&
      (org != null ? org.isFeatureEnabled('csvExport') : undefined)
    ) {
      data.hasCsvExport = true;
      data.csvURL = `/b/${this.model.get('shortLink')}.csv`;
    }

    if (org?.hasPaidProduct() && !org?.isFeatureEnabled('csvExport')) {
      data.needsUpgradeForCsv = true;
    }

    data.jsonURL = `/b/${this.model.get('shortLink')}.json`;

    data.upsellEnabled = !dontUpsell();

    data.featureFlag = featureFlag;

    this.$el.html(popoverShare(data));

    const isFreeTeam = org && !org.hasPaidProduct();
    const isStandard = org && org.isStandard();
    const billingUrl = this.getBillingUrl(org);
    const orgId = org != null ? org.id : undefined;

    const shouldShowUpgradePrompt =
      !data.isAdDismissed &&
      // make sure prompt shows for free and standard
      (isFreeTeam || isStandard) &&
      !data.hasCsvExport &&
      data.upsellEnabled;

    if (shouldShowUpgradePrompt) {
      const $printAndExportUpgradePromptWrapper = this.$(
        '.print-and-export-upgrade-prompt-wrapper',
      )[0];

      renderComponent(
        this.adContainer(orgId),
        $printAndExportUpgradePromptWrapper,
      );
    }

    Analytics.sendScreenEvent({
      name: 'printAndExportBoardInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
      },
    });

    this.upgradePromptPill(billingUrl, orgId);
    return this;
  }

  getBillingUrl(org) {
    if (org) {
      return Controller.getOrganizationBillingUrl(org);
    }
    return '/business-class';
  }

  renderExportPopover() {
    return PopOver.pushView({
      getViewTitle() {
        return l(['view title', 'export board']);
      },
      reactElement: (
        <ComponentWrapper key="exportPopover">
          <ExportPopoverContent idBoard={this.model.id} />
        </ComponentWrapper>
      ),
    });
  }

  adContainer(orgId) {
    return (
      <React.Fragment>
        <hr />
        <UpgradeSmartComponent
          orgId={orgId}
          promptId="moreMenuShareInlineDialogPromptFull"
        />
      </React.Fragment>
    );
  }

  upgradePromptPill(billingUrl, orgId) {
    const bcPillReactRoot = this.$('#js-export-csv-pill-update-prompt')[0];

    const onClick = () => {
      Analytics.sendClickedButtonEvent({
        buttonName: 'upgradeButton',
        source: 'printAndExportBoardInlineDialog',
        containers: {
          board: {
            id: this.model?.id,
          },
          workspace: {
            id: orgId,
          },
        },
      });

      const tempNode = document.createElement('span');
      bcPillReactRoot.appendChild(tempNode);
      return renderComponent(
        <PlanSelectionOverlay
          orgId={orgId}
          // eslint-disable-next-line react/jsx-no-bind
          onContinue={() => window.location.assign('/business-class')}
          // eslint-disable-next-line react/jsx-no-bind
          onClose={() => {
            ReactDOM.unmountComponentAtNode(tempNode);
            return tempNode.remove();
          }}
        />,
        tempNode,
        {
          boardModel: this.model,
        },
      );
    };

    return (this.unmountPill = renderUpgradePrompt(
      <UpgradePromptPill
        cta={l(['upgrade prompt', 'upgrade'])}
        // eslint-disable-next-line react/jsx-no-bind
        ctaOnClick={onClick}
        icon={<BusinessClassIcon />}
        isDismissible={false}
      />,
      bcPillReactRoot,
      {
        boardModel: this.model,
      },
    ));
  }

  printModel(e) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedButtonEvent({
      buttonName: 'printButton',
      source: 'printAndExportBoardInlineDialog',
      containers: {
        board: {
          id: this.model?.id,
        },
        workspace: {
          id: this.model?.getOrganization()?.id,
        },
      },
    });
    PopOver.hide();

    this.defer(() => print());
  }

  exportJSON(e) {
    const exportJsonEl = this.$('.js-export-json');
    exportJsonEl.addClass('disabled');
    showFlag({
      id: 'exportAsJson',
      title: format('exporting-board-as-json'),
      isAutoDismiss: true,
      appearance: 'info',
      msTimeout: 5000,
    });
    return Analytics.sendClickedButtonEvent({
      buttonName: 'exportJSONButton',
      source: 'printAndExportBoardInlineDialog',
      containers: {
        board: {
          id: this.model?.id,
        },
        workspace: {
          id: this.model?.getOrganization()?.id,
        },
      },
    });
  }

  export(e) {
    return Analytics.sendClickedButtonEvent({
      buttonName: 'exportButton',
      source: 'printAndExportBoardInlineDialog',
      containers: {
        board: {
          id: this.model?.id,
        },
        workspace: {
          id: this.model?.getOrganization()?.id,
        },
      },
    });
  }

  fetchCSVData(url, traceId) {
    return fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Trello-Client-Version': clientVersion,
        ...Analytics.getTaskRequestHeaders(traceId),
      },
    });
  }

  async tracedExportCSV(e) {
    const traceId = Analytics.startTask({
      taskName: 'create-export/board',
      source: 'printAndExportBoardInlineDialog',
    });

    // DAE is bringing feature flag attribution to VitalStats. This is a one-off
    // enrichment to create a sample of flag-attributed events. It will be removed
    // when attribution is handled within the FeatureFlagClient and AnalyticsClient.
    const flagAttributes = {
      flags: {
        'fv.export-service-export-board': featureFlag,
      },
    };

    try {
      const url = e?.target?.href;
      const response = await this.fetchCSVData(url, traceId);

      const trelloServerVersion = response.headers.get('X-Trello-Version');
      Analytics.setTrelloServerVersion(traceId, trelloServerVersion);

      if (!response.ok) {
        const { error } = await response.json();
        if (error === 'API_TOO_MANY_CARDS_REQUESTED') {
          showFlag({
            id: 'exportCardsErrorTooManyCards',
            title: format('exporting-board-error-too-many-cards-title'),
            description: format(
              'exporting-board-error-too-many-cards-description',
            ),
            actions: [
              {
                content: format('exporting-board-error-too-many-cards-dismiss'),
                onClick: () =>
                  dismissFlag({ id: 'exportCardsErrorTooManyCards' }),
                type: 'button',
              },
            ],
            appearance: 'error',
          });
        }

        Analytics.taskFailed({
          taskName: 'create-export/board',
          traceId,
          source: 'printAndExportBoardInlineDialog',
          error: new Error(`${response.status}: Failed to fetch CSV export`),
          attributes: flagAttributes,
        });
        return;
      }

      const blob = await response.blob();
      const shortLink = this.model.get('shortLink');
      const slug = makeSlug(this.model.get('name'));
      const filename = `${shortLink} - ${slug}.csv`;

      const link = document.createElement('a');
      link.download = filename;
      link.href = window.URL.createObjectURL(blob);

      // Simulate click to download CSV file
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Analytics.taskSucceeded({
        taskName: 'create-export/board',
        traceId,
        source: 'printAndExportBoardInlineDialog',
        attributes: flagAttributes,
      });
    } catch (error) {
      throw Analytics.taskFailed({
        taskName: 'create-export/board',
        traceId,
        source: 'printAndExportBoardInlineDialog',
        error,
        attributes: flagAttributes,
      });
    }
  }

  exportCSV(e) {
    // since we need to instrument the download success/failure, we're going to
    // prevent the default anchor/browser behaviour and make the XMLHttpRequest
    // ourselves with associated instrumentation
    stopPropagationAndPreventDefault(e);

    this.debouncedTracedExport(e);

    return Analytics.sendClickedButtonEvent({
      buttonName: 'exportCSVButton',
      source: 'printAndExportBoardInlineDialog',
      containers: {
        board: {
          id: this.model?.id,
        },
        workspace: {
          id: this.model?.getOrganization()?.id,
        },
      },
    });
  }
}

SharePopoverView.initClass();
export { SharePopoverView };
